import { SegmentFilters, } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerReportDetail";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
import { openBase64PDFInNewTab } from "@domains/utils/fileMethods";
import * as moment from "moment";
import { FilterData, Filters, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { LedgerDetailUIState } from "@domains/aggregates/Reports/LedgerUIState";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
class LedgerReport {
    constructor(actions, usecases, emailUsecase, downloadPDFUseCase, downloadExcelUseCase, LedgerCommonUseCase) {
        this.actions = actions;
        this.usecases = usecases;
        this.emailUsecase = emailUsecase;
        this.downloadPDFUseCase = downloadPDFUseCase;
        this.downloadExcelUseCase = downloadExcelUseCase;
        this.LedgerCommonUseCase = LedgerCommonUseCase;
        this.allTypeOfExchangeFilters = [
            { title: "NSE", key: "NSE", selected: false },
            { title: "BSE", key: "BSE", selected: false },
            { title: "NSEC", key: "NSEC", selected: false },
            { title: "BSEC", key: "BSEC", selected: false },
            { title: "NSEF", key: "NSEF", selected: false },
            { title: "BSEF", key: "BSEF", selected: false },
        ];
        this.allTypeOfExchangeFiltersCommodity = [
            { title: "MCX", key: "MCX", selected: false },
            { title: "NCDEX", key: "NCDEX", selected: false },
        ];
        this.allTypeOfVoucherFilters = [
            { title: "OPBAL", key: "OPBAL", selected: false },
            { title: "Bills", key: "BILL", selected: false },
            { title: "Payment", key: "PAYMENT", selected: false },
            { title: "Receipt", key: "RECEIPT", selected: false },
            { title: "JV", key: "JV", selected: false },
        ];
        this.allSegmentFilters = [
            { title: "All Segments", key: SegmentFilters.ALL, selected: false },
            { title: "Cash", key: SegmentFilters.CASH, selected: false },
            { title: "F&O", key: SegmentFilters.DERIVATIVE, selected: false },
            { title: "Currency", key: SegmentFilters.CURRENCY, selected: false },
            { title: "Funds brought in", key: SegmentFilters.PAYIN, selected: false },
            { title: "Funds moved out", key: SegmentFilters.PAYOUT, selected: false },
        ];
        this.filterState = new FilterData(new Filters("simpleFilter", this.allTypeOfVoucherFilters), new Filters("assetFilter", this.allTypeOfExchangeFilters), new Filters("productAssetFilter", this.allSegmentFilters));
        this.emailList = [];
    }
    getLedgerSnapShot(req) {
        this.actions.snapShot.getLedgerSnapShot([], "snapShot");
        this.actions.snapShot.hideError("snapShot");
        this.actions.snapShot.loader("snapShot");
        this.usecases.snapShot.execute({
            onSuccess: (data) => {
                this.actions.snapShot.getLedgerSnapShot(data, "snapShot");
                this.actions.snapShot.stopLoader("snapShot");
            },
            onError: (error) => {
                this.actions.snapShot.stopLoader("snapShot");
                this.actions.snapShot.setError({ isOpen: true, error }, "snapShot");
            },
        }, req);
    }
    getLedgerDetail(req) {
        this.actions.details.hideError("details");
        this.actions.details.clear("details");
        this.actions.details.loader("details");
        this.actions.details.getLedgerDetails([], "details");
        this.usecases.detail.execute({
            onSuccess: (data) => {
                if (!!data && data.length < 1) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.LEDGER];
                    this.actions.details.addMsg(emptyValidation.message, true, emptyValidation.icon, "details");
                }
                else {
                    this.ledgerDetails = data;
                    this.actions.details.clear("details");
                    this.filterState = new FilterData(new Filters("simpleFilter", this.allTypeOfVoucherFilters), new Filters("assetFilter", req.accType === ILoginAccountTypes.EQ
                        ? this.allTypeOfExchangeFilters
                        : this.allTypeOfExchangeFiltersCommodity), new Filters("productAssetFilter", this.allSegmentFilters));
                    this.actions.details.getLedgerDetails(data, "details");
                    this.actions.details.setFilterData(this.filterState, "details");
                }
                this.actions.details.stopLoader("details");
            },
            onError: (error) => {
                this.actions.details.stopLoader("details");
                this.actions.details.setError({ isOpen: true, error }, "details");
            },
        }, req);
    }
    async downloadAndSendLedgerReport(email, download) {
        try {
            if (email && download) {
                const emailResult = await this.sendLedgerEmail(email);
                const downloadResult = await this.DownloadLedgerReport(download);
                return emailResult && downloadResult;
            }
            else if (email)
                return await this.sendLedgerEmail(email);
            else if (download)
                return await this.DownloadLedgerReport(download);
            throw false;
        }
        catch (error) {
            throw false;
        }
    }
    async DownloadLedgerReport(downloadPayload) {
        if (downloadPayload.reportType === ReportType.PDF)
            return await this.downloadLedgerHelper(this.downloadPDFUseCase, downloadPayload);
        return await this.downloadLedgerHelper(this.downloadExcelUseCase, downloadPayload);
    }
    async downloadLedgerHelper(DType, downloadPayload) {
        downloadPayload.reportName = ReportName.LEDGER;
        return new Promise((resolve, reject) => {
            DType.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, downloadPayload);
        });
    }
    async sendLedgerEmail(req) {
        req.reportName = ReportName.LEDGER;
        this.emailList = req.emailIds;
        return new Promise((resolve, reject) => {
            this.emailUsecase.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
    snapShotExtentionDetails(req) {
        this.actions.snapshotExtention.hideError("snapShotExtention");
        this.actions.snapshotExtention.clear("snapShotExtention");
        this.actions.snapshotExtention.loader("snapShotExtention");
        this.actions.snapshotExtention.snapShotExtention([], "snapShotExtention");
        this.usecases.snapshotExtention.execute({
            onSuccess: (data) => {
                if (!!data && data.length < 1) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.LEDGER];
                    this.actions.details.addMsg(emptyValidation.message, true, emptyValidation.icon, "snapShotExtention");
                }
                else {
                    this.actions.snapshotExtention.clear("snapShotExtention");
                    this.actions.snapshotExtention.snapShotExtention(data, "snapShotExtention");
                }
                this.actions.snapshotExtention.stopLoader("snapShotExtention");
            },
            onError: (error) => {
                this.actions.snapshotExtention.stopLoader("snapShotExtention");
                this.actions.snapshotExtention.setError({ isOpen: true, error }, "snapShotExtention");
            },
        }, req);
    }
    downloadAndShowLedgerDetailContractPDF(req) {
        return new Promise((resolve, reject) => {
            this.usecases.contractPDF.execute({
                onSuccess: (resp) => {
                    openBase64PDFInNewTab(resp.data, "LEDGER_" + moment(new Date()).format("DD-MM-YY"));
                    resolve(resp.status);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
    contractNote(req) {
        this.actions.contractNote.hideError("contractNote");
        this.actions.contractNote.clear("contractNote");
        this.actions.contractNote.contractNote([], "contractNote");
        this.actions.contractNote.loader("contractNote");
        this.usecases.contractNote.execute({
            onSuccess: (data) => {
                if (!!data && data.length < 1) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.LEDGER];
                    this.actions.contractNote.addMsg("No results found!", true, emptyValidation.icon, "contractNote");
                }
                else {
                    this.actions.contractNote.clear("contractNote");
                    this.actions.contractNote.contractNote(data, "contractNote");
                }
                this.actions.contractNote.stopLoader("contractNote");
            },
            onError: (error) => {
                this.actions.contractNote.stopLoader("contractNote");
                this.actions.contractNote.setError({ isOpen: true, error }, "contractNote");
            },
        }, req);
    }
    getFilteredLedgerDetails(filterState) {
        this.filterState = filterState;
        let combinedState = new LedgerDetailUIState(this.filterState);
        let modifiedData = {
            ledgerDetails: this.ledgerDetails,
            FilterData: this.filterState,
        };
        this.actions.details.clear("details");
        this.LedgerCommonUseCase.getModifiedData(modifiedData, combinedState).then((val) => {
            var _a;
            this.actions.details.setFilterData(val.FilterData, "details");
            if (((_a = val.ledgerDetails) === null || _a === void 0 ? void 0 : _a.length) > 0)
                this.actions.details.getLedgerDetails(val.ledgerDetails, "details");
            else {
                if (this.filterApplied()) {
                    const emptyValidation = EmptyValidation[EmptyIcon.FILTER];
                    this.actions.details.addMsg(emptyValidation.message, true, emptyValidation.icon, "details");
                }
            }
        });
    }
    clearAllFilters(avoidclearingProductFilters) {
        for (let filter in this.filterState) {
            if (avoidclearingProductFilters &&
                this.filterState[filter] &&
                this.filterState[filter].name ===
                    this.filterState.productAssetFilter.name)
                continue;
            if (this.filterState[filter])
                this.filterState[filter].filters.forEach((singleFilter) => {
                    singleFilter.selected = false;
                });
        }
        this.getFilteredLedgerDetails(this.filterState);
    }
    filterApplied() {
        let filterApplied = false;
        for (let filter in this.filterState) {
            if (this.filterState[filter])
                this.filterState[filter].filters.forEach((x) => {
                    if (x.selected === true)
                        filterApplied = true;
                });
        }
        return filterApplied;
    }
    //remove setOf Filter
    removeFilters(filters) {
        filters.forEach((singleFilter) => {
            singleFilter.selected = false;
        });
    }
    selectSegmentFilter(selectedFilter) {
        this.removeFilters(this.filterState.simpleFilter.filters);
        this.removeFilters(this.filterState.assetFilter.filters);
        this.actions.details.setFilterData(this.filterState, "details");
        this.filterState.productAssetFilter.filters.forEach((x) => {
            if (x.key === selectedFilter)
                x.selected = true;
            else
                x.selected = false;
        });
        this.segmentFilterHelper(selectedFilter);
        this.getFilteredLedgerDetails(this.filterState);
    }
    segmentFilterHelper(selectedFilter) {
        switch (selectedFilter) {
            case SegmentFilters.CASH:
                this.filterState.assetFilter.filters =
                    this.allTypeOfExchangeFilters.filter((val) => {
                        return (val.key == this.allTypeOfExchangeFilters[0].key ||
                            val.key == this.allTypeOfExchangeFilters[1].key);
                    });
                this.filterState.simpleFilter.filters =
                    this.allTypeOfVoucherFilters.filter((val) => val.key !== this.allTypeOfVoucherFilters[0].key);
                break;
            case SegmentFilters.DERIVATIVE:
                this.filterState.assetFilter.filters = [
                    this.allTypeOfExchangeFilters[4],
                    this.allTypeOfExchangeFilters[5],
                ];
                this.filterState.simpleFilter.filters =
                    this.allTypeOfVoucherFilters.filter((val) => val.key !== this.allTypeOfVoucherFilters[0].key &&
                        val.key !== this.allTypeOfVoucherFilters[3].key);
                break;
            case SegmentFilters.CURRENCY:
                this.filterState.assetFilter.filters = [
                    this.allTypeOfExchangeFilters[2],
                    this.allTypeOfExchangeFilters[3],
                ];
                this.filterState.simpleFilter.filters =
                    this.allTypeOfVoucherFilters.filter((val) => val.key !== this.allTypeOfVoucherFilters[0].key &&
                        val.key !== this.allTypeOfVoucherFilters[3].key);
                break;
            case SegmentFilters.PAYIN:
                this.filterState.simpleFilter.filters =
                    this.allTypeOfVoucherFilters.filter((val) => val.key === this.allTypeOfVoucherFilters[3].key);
                this.filterState.assetFilter.filters = this.allTypeOfExchangeFilters;
                break;
            case SegmentFilters.PAYOUT:
                this.filterState.simpleFilter.filters =
                    this.allTypeOfVoucherFilters.filter((val) => val.key === this.allTypeOfVoucherFilters[2].key);
                this.filterState.assetFilter.filters = this.allTypeOfExchangeFilters;
                break;
            default:
                this.filterState.simpleFilter.filters = this.allTypeOfVoucherFilters;
                this.filterState.assetFilter.filters = this.allTypeOfExchangeFilters;
        }
    }
    sortLedgerDetails(sortData, sortRecord, data) {
        this.actions.details.setSortData({
            sortState: sortData,
            sortRecord: sortRecord,
            data: data,
        }, "details");
        this.actions.details.getLedgerDetails(data, "details");
    }
    clearSortData() {
        this.actions.details.clearSortData("details");
    }
    removeOneFilter(clearThisFilter) {
        let clearFound = false;
        let updatedFilter = [];
        let keyFound = null;
        Object.entries(this.filterState).forEach((val) => {
            var _a;
            if (clearFound)
                return;
            if (val[0] && ((_a = val[1]) === null || _a === void 0 ? void 0 : _a.filters)) {
                updatedFilter = val[1].filters.map((x) => {
                    if (x.title === clearThisFilter) {
                        x.selected = false;
                        clearFound = true;
                        keyFound = val[0];
                        this.removeOneFilterFromSession(val, x);
                    }
                    return x;
                });
            }
        });
        if (clearFound)
            this.getFilteredLedgerDetails(Object.assign(Object.assign({}, this.filterState), { [keyFound]: new Filters(keyFound, updatedFilter) }));
    }
    removeOneFilterFromSession(val, x) {
        let FilterInSession = JSON.parse(sessionStorage.getItem(val[0]));
        if (FilterInSession && FilterInSession[0].value.length > 0) {
            FilterInSession[0].value.forEach((item) => {
                if (x.title === item) {
                    x.selected = false;
                    let newSessionFilter = FilterInSession[0].value;
                    const index = FilterInSession[0].value.indexOf(x.title);
                    if (index > -1)
                        FilterInSession[0].value.splice(index, 1);
                    sessionStorage.setItem(val[0], JSON.stringify([{ key: [val[0]], value: newSessionFilter }]));
                }
            });
        }
        if ((FilterInSession === null || FilterInSession === void 0 ? void 0 : FilterInSession.length) === 1)
            sessionStorage.removeItem(val[0]);
    }
}
export default LedgerReport;
